import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pt-10" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新建预算")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("设置管理员")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_10 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("固定金额")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("按订单金额百分比")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确定")

import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, {cpyCfig} from '@/global_mixin/tableMixin'
import { defineComponent, ref, Ref, reactive, onBeforeMount, onMounted } from 'vue'
import { getDropBoxHandle } from '@/views/ViewsComponents/financial/bankDropBox'
import type { FormInstance, FormRules } from 'element-plus'
import { formatNumber } from '@/utils/index'
import { useRoute,useRouter} from 'vue-router'
import dayjs from "dayjs"

import Api from '@/http/modules/index'
import { derivative } from 'mathjs'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
    // 预算维护_获取列表(树状)
    'POST/budget/tree':budgetTreeApi,
    // 预算维护_新增
    'POST/budget':budgetApi,
    // 预算维护_修改
    'PATCH/budget':budgetPatchApi,
    // 预算维护_关闭
    'POST/budget/close':budgetCloseApi,
    // 预算维护_设置管理员
    'POST/budget/set_budget_admin':budgetSetAdminApi,
    // 所属团队
    'GET/organizations':organizationsApi,
    // 用户下拉列表
    'GET/users/list': usersListApi,
    // 修改记录
    'GET/budget/{id}/modify_record': modifyRecordApi,
} = Api
const tableHeight=window.innerHeight-150
const router=useRouter()
const allowChange=ref()
const budgetList=ref<any>([])
const loading=reactive({
    table:false,
    addhandle:false,
    setAdmin:false
})
console.log(dayjs('2024-05-29T09:15:33').format("YYYY-MM-DD HH:mm:ss"))
//预算状态   EFFECTIVE, //已生效 EXPIRED, //已失效 CLOSED //已关闭
const budgetStatusList=[
    {value:'EFFECTIVE',label:'已生效'},
    {value:'EXPIRED',label:'已失效'},
    {value:'CLOSED',label:'已关闭'},
]
const queryInfo=ref<any>({})
const getBudgetList=(isReset:boolean=false)=>{
    if(isReset){
        queryInfo.value={}
    }
    
    let {orgId,itemName,status,rangeStartDate,rangeEndDate}=queryInfo.value
    let params={
        orgId:orgId||'',itemName:itemName||'',status:status||'',
        rangeStartDate:{
            from:rangeStartDate&&rangeStartDate.length?dayjs(rangeStartDate[0]).format('YYYY-MM-DD'):'',
            to:rangeStartDate&&rangeStartDate.length?dayjs(rangeStartDate[1]).format('YYYY-MM-DD'):'',
        },
        rangeEndDate:{
            from:rangeEndDate&&rangeEndDate.length?dayjs(rangeEndDate[0]).format('YYYY-MM-DD'):'',
            to:rangeEndDate&&rangeEndDate.length?dayjs(rangeEndDate[1]).format('YYYY-MM-DD'):'',
        }
    }
    loading.table=true
    budgetTreeApi(params).then((res:any)=>{
        // res.forEach((el:any) => {
        //     el.children=el.childList
        // });
        budgetList.value=res
        loading.table=false
    }).catch(()=>{
        loading.table=false
    })
}
// 新建预算
const budgetVisiable=ref(false)
const budgetForm=ref<any>({
    settingMethod:0,
    currency:'CNY',
    belongDepartment:[]
})
const organizationLists=ref([])
const budgetFormRef=ref()
const currencyLists=ref([])
const isAdd=ref(true) //判断是新增还/修改操作
const budgetFormRules=ref({
    // pid:{required:true,message:'请输入上级编码'},
    itemCode:{required:true,message:'请输入预算科目编码'},
    itemName:{required:true,message:'请输入预算科目名称'},
    budgetAmount:{required:false,message:'请输入预算金额'},
    currency:{required:true,message:'请选择预算币种'},
    department:{required:true,message:'请选择归属部门'},
    startDate:{required:true,message:'请选择预算执行日'},
    endDate:{required:true,message:'请选择预算结束日'},
    type:{required:true,message:'请选择预算类型'},
    belongDepartment:{required:true,message:'请选择订单归属部门',trigger:'change'},
    percentage:{required:true,message:'请输入百分比'}
})
const budgetTypeList=[
    {label:"普通预算",value:'ORDINARY'},
    {label:"部门经费",value:'DEPARTMENT'}
]
const amountRecords=ref([])
const otherRecords=ref([])
const filterBudgetType=(type:string)=>{
    switch(type){
        case 'ORDINARY':
            return "普通预算"
        case 'DEPARTMENT':
            return "部门经费"
        return ''
    }
}
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
        let {pid,itemCode,itemName,budgetAmount,startDate,endDate,department,id,currency,type,belongDepartment,settingMethod,percentage}=budgetForm.value

        let params={
            pid:pid||id||0,itemCode,itemName,budgetAmount:budgetAmount||0,department,type,belongDepartment,settingMethod,percentage,currency,
            startDate:dayjs(startDate).format("YYYY-MM-DD"),
            endDate:dayjs(endDate).format("YYYY-MM-DD"),
            id
        }
        if(settingMethod=='0'){ //固定金额
            delete params.percentage
            delete params.belongDepartment
        }else{ //百分比
            delete params.currency
            delete params.budgetAmount
        }
        loading.addhandle=true
        if(!isAdd.value){ //修改
            budgetPatchApi(params).then(res=>{
                budgetVisiable.value=false
                ElMessage.success('修改成功')
                getBudgetList()
            }).finally(()=>{
                loading.addhandle=false
            })
            return
        }
        // 新增
        delete params.id //去除id项
        budgetApi(params).then(res=>{
            budgetVisiable.value=false
            ElMessage.success('创建成功')
            getBudgetList()
        }).finally(()=>{
            loading.addhandle=false
        })
    }
  })
}
const closeBudgetVisiable=(formEl: FormInstance | undefined)=>{
    if (!formEl) return
    formEl.resetFields()
    budgetForm.value={
        settingMethod:0,currency:'CNY',belongDepartment:[]
    }
    isAdd.value=true
    allowChange.value=false
}
// 添加下级/修改预算
const recordLoading=ref(false)
const modifyHandel=(data:any,handelType:string)=>{
    budgetVisiable.value=true
    isAdd.value=handelType==='add' //判断是新增还是修改    
    budgetForm.value=isAdd.value?{ id:data.id,settingMethod:0,currency:'CNY',belongDepartment:[]}:JSON.parse(JSON.stringify(data))
    recordLoading.value=true
    modifyRecordApi({id:data.id}).then((res:any)=>{
        amountRecords.value=res.amount
        otherRecords.value=res.others
    }).catch(()=>{
        amountRecords.value=[]
        otherRecords.value=[]
    }).finally(()=>{
        recordLoading.value=false
    })
}

// 关闭
const closeHandel=(id:any)=>{
    ElMessageBox.confirm('确定关闭预算？',{confirmButtonText:'确定',cancelButtonText:'取消'}).then(()=>{
        budgetCloseApi({id}).then(()=>{
            ElMessage.success('关闭成功')
            getBudgetList()
        })
    })
}

// 归属部门映射
const departmentCorr=(id:any)=>{
    let res:any=organizationLists.value.find((el:any)=>el.id==id)
    return res?res.name:""
}

// ID补0操作，显示ID为4位数
const addIdLength=(num:any,length:any)=>{
    return ( '0000000000000000' + num ).substr( -length );
}
// formatTime
const formatTime=(time:any)=>{
    return time?dayjs(time).format("YYYY-MM-DD HH:mm:ss"):''
}

// 设置管理员
const userLists=ref([])
const budgetAdminVisiable=ref(false)
const currentBudgetId=ref("")
const currentBudgetAdminId=ref([])
const openSet=(data:any)=>{
    currentBudgetId.value=data.id
    budgetAdminVisiable.value=true
    currentBudgetAdminId.value=data.budgetAdmin
}
const closeSet=()=>{
    currentBudgetId.value=""
    currentBudgetAdminId.value=[]
}
const setBudgetAdmin=()=>{
    if(!currentBudgetAdminId.value.length){
        ElMessage.warning("请选择管理人员")
        return
    }
    let params={
        id:currentBudgetId.value,
        budgetAdmin:currentBudgetAdminId.value
    }
    loading.setAdmin=true
    budgetSetAdminApi(params).then((params)=>{
        ElMessage.success('设置成功')
        budgetAdminVisiable.value=false
        getBudgetList()
    }).finally(()=>{
        loading.setAdmin=false
    })
}
const goDetail=(data:any)=>{
    router.push({name:"budgetMaintenanceDetail",params:{id:data.id}})
}
const formatOps=(data:any,ops:string)=>{
    if(data.fieldName=='金额设置方式'){
        if(data[ops]==-1){
            return "未设置"
        } 
        return data[ops]==0?'固定金额':'百分比'
    }
    return data[ops]
}
onMounted(()=>{
    getBudgetList()
    organizationsApi().then((res:any)=>{
        organizationLists.value=res
    })
    getDropBoxHandle().then((res:any)=>{
        currencyLists.value=res.currency
    })
    usersListApi().then((res:any)=>{
        userLists.value=res
    })
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "预算维护搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              inline: "",
              model: queryInfo.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "归属部门" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryInfo.value.orgId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryInfo.value.orgId) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationLists.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            value: item.id,
                            label: item.name
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "预算科目名称 " }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryInfo.value.itemName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryInfo.value.itemName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "预算执行日" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: queryInfo.value.rangeStartDate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryInfo.value.rangeStartDate) = $event)),
                      type: "daterange",
                      "range-separator": "To",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "预算结束日" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: queryInfo.value.rangeEndDate,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryInfo.value.rangeEndDate) = $event)),
                      type: "daterange",
                      "range-separator": "To",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryInfo.value.status,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryInfo.value.status) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(budgetStatusList, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            value: item.value,
                            label: item.label
                          }, null, 8, ["value", "label"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: " " }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (getBudgetList()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (getBudgetList(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (budgetVisiable.value=true))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      height: tableHeight,
      "row-key": "id",
      data: budgetList.value,
      border: "",
      class: "mt-10",
      "default-expand-all": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          width: "160",
          formatter: (row)=>addIdLength(row.id,4)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "itemCode",
          label: "预算科目编码"
        }),
        _createVNode(_component_el_table_column, {
          prop: "pid",
          label: "上级编码"
        }),
        _createVNode(_component_el_table_column, {
          prop: "department",
          label: "归属部门",
          formatter: (row)=>departmentCorr(row.department),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "itemName",
          label: "预算科目名称",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "预算类型",
          width: "120",
          "show-overflow-tooltip": "",
          formatter: (row)=>filterBudgetType(row.type)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "currency",
          label: "预算币种"
        }),
        _createVNode(_component_el_table_column, {
          prop: "budgetAmount",
          label: "预算金额",
          align: "right",
          formatter: _unref(formatNumber),
          width: "120"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "budgetExecutionAmount",
          label: "预算执行金额",
          align: "right",
          formatter: _unref(formatNumber),
          width: "120"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "startDate",
          label: "预算执行日",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "endDate",
          label: "预算结束日",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "budgetAdminName",
          label: "预算管理员",
          formatter: (row)=>row.budgetAdminName?row.budgetAdminName.join(','):'',
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "预算关闭",
          formatter: (row)=>budgetStatusList.find(el=>el.value==row.status).label
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "closeTime",
          label: "关闭日期",
          "show-overflow-tooltip": "",
          formatter: (row)=>formatTime(row.closeTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "ops",
          label: "操作",
          width: "250"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: ($event: any) => (goDetail(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: ($event: any) => (modifyHandel(row,'add'))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: ($event: any) => (modifyHandel(row,'modify'))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: ($event: any) => (openSet(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: ($event: any) => (closeHandel(row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(loading).table]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: budgetVisiable.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((budgetVisiable).value = $event)),
      title: isAdd.value?'新建预算':'修改预算',
      width: "800",
      onClose: _cache[23] || (_cache[23] = ($event: any) => (closeBudgetVisiable(budgetFormRef.value)))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[20] || (_cache[20] = ($event: any) => (budgetVisiable.value=false))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _unref(loading).addhandle,
              onClick: _cache[21] || (_cache[21] = ($event: any) => (submitForm(budgetFormRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          ref_key: "budgetFormRef",
          ref: budgetFormRef,
          rules: budgetFormRules.value,
          model: budgetForm.value,
          "label-width": "120",
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "预算科目编码",
              prop: "itemCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"220px"},
                  modelValue: budgetForm.value.itemCode,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((budgetForm.value.itemCode) = $event)),
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "预算科目名称",
              prop: "itemName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"220px"},
                  modelValue: budgetForm.value.itemName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((budgetForm.value.itemName) = $event)),
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "预算类型",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"220px"},
                  modelValue: budgetForm.value.type,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((budgetForm.value.type) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(budgetTypeList, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "所属部门",
              prop: "department"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"220px"},
                  modelValue: budgetForm.value.department,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((budgetForm.value.department) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationLists.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "预算执行日",
              prop: "startDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: budgetForm.value.startDate,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((budgetForm.value.startDate) = $event)),
                  type: "date",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "预算结束日",
              prop: "endDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: budgetForm.value.endDate,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((budgetForm.value.endDate) = $event)),
                  type: "date",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            (!isAdd.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: allowChange.value,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((allowChange).value = $event)),
                    label: "修改金额",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "金额设置方式",
              prop: "settingMethod"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  disabled: !allowChange.value&&!isAdd.value,
                  modelValue: budgetForm.value.settingMethod,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((budgetForm.value.settingMethod) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: " ",
              prop: " "
            }),
            (budgetForm.value.settingMethod=='1')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "百分比(%)",
                  prop: "percentage"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      disabled: !allowChange.value&&!isAdd.value,
                      class: "percentage-input",
                      controls: false,
                      style: {"width":"220px"},
                      max: "100",
                      modelValue: budgetForm.value.percentage,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((budgetForm.value.percentage) = $event)),
                      clearable: ""
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (budgetForm.value.settingMethod=='0')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "预算币种",
                  prop: "currency"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      disabled: !allowChange.value&&!isAdd.value,
                      style: {"width":"220px"},
                      modelValue: budgetForm.value.currency,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((budgetForm.value.currency) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencyLists.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.label,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (budgetForm.value.settingMethod=='0')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  label: "预算金额",
                  prop: "budgetAmount"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: !allowChange.value&&!isAdd.value,
                      style: {"width":"220px"},
                      modelValue: budgetForm.value.budgetAmount,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((budgetForm.value.budgetAmount) = $event)),
                      clearable: ""
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (budgetForm.value.settingMethod=='1')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 4,
                  label: "订单归属部门",
                  prop: "belongDepartment"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      disabled: !allowChange.value&&!isAdd.value,
                      "collapse-tags": "",
                      "collapse-tags-tooltip": "",
                      multiple: "",
                      style: {"width":"220px"},
                      modelValue: budgetForm.value.belongDepartment,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((budgetForm.value.belongDepartment) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationLists.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rules", "model"]),
        (!isAdd.value)
          ? (_openBlock(), _createBlock(_component_el_collapse, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "展开修改记录" }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                      "max-height": "300",
                      data: amountRecords.value,
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          type: "index",
                          width: "80",
                          label: "序号"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "original",
                          label: "修改前金额",
                          align: "right"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "target",
                          label: "修改后金额",
                          align: "right"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "operatorName",
                          label: "操作人"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "operationTime",
                          label: "操作时间",
                          formatter: (row)=>formatTime(row.operationTime)
                        }, null, 8, ["formatter"])
                      ]),
                      _: 1
                    }, 8, ["data"])), [
                      [_directive_loading, recordLoading.value]
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                      "max-height": "300",
                      data: otherRecords.value,
                      border: "",
                      class: "mt-10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          type: "index",
                          width: "80",
                          label: "序号"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "fieldName",
                          label: "修改属性名"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "original",
                          label: "修改前其他属性"
                        }, {
                          default: _withCtx(({row}) => [
                            _createTextVNode(_toDisplayString(formatOps(row,'original')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "target",
                          label: "修改后其他属性"
                        }, {
                          default: _withCtx(({row}) => [
                            _createTextVNode(_toDisplayString(formatOps(row,'target')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "operatorName",
                          label: "操作人"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "operationTime",
                          label: "操作时间",
                          "show-overflow-tooltip": "",
                          formatter: (row)=>formatTime(row.operationTime)
                        }, null, 8, ["formatter"])
                      ]),
                      _: 1
                    }, 8, ["data"])), [
                      [_directive_loading, recordLoading.value]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: budgetAdminVisiable.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((budgetAdminVisiable).value = $event)),
      title: "设置管理员",
      onClose: closeSet,
      width: "400"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[25] || (_cache[25] = ($event: any) => (budgetAdminVisiable.value=false))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _unref(loading).setAdmin,
              onClick: setBudgetAdmin
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          style: {"width":"300px"},
          placeholder: "请选择管理人员",
          "collapse-tags": "",
          "collapse-tags-tooltip": "",
          filterable: "",
          clearable: "",
          multiple: "",
          modelValue: currentBudgetAdminId.value,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((currentBudgetAdminId).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.userId,
                label: `${item.realName}(${item.username})`,
                value: item.userId
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})